import React, { useState, useEffect } from "react";
import { Switch, Route, useLocation, Redirect } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { useBeforeFirstRender } from "./hooks/customHooks";
import {
  fireViewStartCustomEvent,
  fireViewEndCustomEvent,
} from "./utils/adobe-launch";
import {
  handleUpdatePageInfoData,
  pageNameConverter,
} from "./utils/storeConverter";

import MySketchFab from "./components/MySketchFab/MySketchFab";
import ActivityHolder from "./components/ActivityHolder/ActivityHolder";
import AvatarText from "./components/AvatarText/AvatarText";
import Menu from "./components/Menu/Menu";

import "./App.css";
import Overlay from "./components/UI/Overlay/Overlay";
import MyHero from "./components/MyHero/MyHero";

function App(props) {
  // console.clear();
  var location = useLocation();

  useBeforeFirstRender(() => {
    const splitPath = location.pathname.split("/");
    const page_name = pageNameConverter(splitPath);

    handleUpdatePageInfoData({
      page_name: page_name,
      page_title: "courtney: orange valley mall",
      game_name: "courtney",
      site_country: "us",
      site_language: "en",
    });

    fireViewStartCustomEvent(window.digitalData);
  });

  useEffect(() => {
    fireViewEndCustomEvent();
  }, []);

  const [openMenu, setOpenMenu] = useState(false);
  const [storeNum, setStoreNum] = useState(1);
  const [floorOne, setFloorOne] = useState(true);
  const [playerObject, setPlayerObject] = useState(null);
  const [isEnterMall, setIsEnterMall] = useState(true);

  const handleMenuToggle = () => {
    setOpenMenu(!openMenu);
  };

  const handleStoreNumChange = (nextStoreNum) => {
    nextStoreNum <= 4 ? setFloorOne(true) : setFloorOne(false);
    setStoreNum((storeNum) => nextStoreNum);
  };

  const handleFloorToggle = () => {
    setFloorOne((floorOne) => !floorOne);
  };

  const handlePlayerObject = (updatedPlayerObj) => {
    setPlayerObject((playerObject) => updatedPlayerObj);
  };

  const menu = (
    <Menu
      location={location}
      openMenu={openMenu}
      menuToggle={handleMenuToggle}
      currentStoreNum={storeNum}
      changeStoreNum={handleStoreNumChange}
      isFloorOne={floorOne}
      changeFloorOne={handleFloorToggle}
    />
  );

  return (
    <>
      <MySketchFab
        model="725cd262988b45869dd4c10d4a401b3a"
        location={location}
      />
      <AnimatePresence exitBeforeEnter>
        <Switch location={location} key={location.key}>
          <Route
            render={(props) => (
              <ActivityHolder
                {...props}
                videoPlayerObject={playerObject}
                changeVideoPlayerObject={handlePlayerObject}
              />
            )}
            path="/store/:id/:activity/"
            exact
          />
          <Route
            render={(props) => (
              <AvatarText
                {...props}
                changeOpenMenu={handleFloorToggle}
                changeStoreNum={handleStoreNumChange}
              />
            )}
            path="/store/:id"
            exact
          />
          <Route
            render={(props) => (
              <Overlay {...props}>
                <MyHero changeEnterMall={setIsEnterMall} />
              </Overlay>
            )}
            path="/"
          />
          <Route>
            <Redirect from="*" to="/" />
          </Route>
        </Switch>
      </AnimatePresence>
      {isEnterMall ? null : menu}
    </>
  );
}

export default App;
